import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
// `GET …/template-file` and `POST …/exports` carry no body: the target document is entirely in the URL.
class ExportDocument {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly documentId: number,
	) {
		Object.freeze(this);
	}
}

export default ExportDocument;
